import React from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "@/assets/svg/Logo";
import { RiseUserActionCapacityEnum as Capacity } from "@/__generated__/types";
import { StrategyBoardState } from "./util";

interface CapacityPickerProps {
  firstName: string;
  boardState: StrategyBoardState;
  onCapacitySelect: (capacity: Capacity) => void;
}

export function CapacityPicker({
  firstName,
  boardState,
  onCapacitySelect,
}: CapacityPickerProps) {
  const { t } = useTranslation();

  let message = "";
  switch (boardState) {
    case StrategyBoardState.NO_ASSIGNED_STUDENTS:
      message = t("strategyBoard.capacityPicker.noStudents");
      break;
    case StrategyBoardState.NOT_READY:
      message = t("strategyBoard.capacityPicker.inProgress");
      break;
    case StrategyBoardState.SET_GOAL:
      message = t("strategyBoard.capacityPicker.capacity");
      break;
    case StrategyBoardState.EMPTY:
      message = t("strategyBoard.capacityPicker.noActions");
      break;
  }

  return (
    <div className="flex h-full flex-col items-center justify-center bg-gradient-to-b from-blue-500/10 via-purple-500/10 to-background/10">
      <div className="h-[60px] w-[60px]">
        <Logo />
      </div>

      <h1 className="mt-4 text-center text-2xl leading-6 font-semibold text-card-foreground">
        {t("strategyBoard.capacityPicker.title", { firstName })}
      </h1>

      <p className="mt-[45px] text-center text-base leading-4 font-semibold text-card-foreground">
        {message}
      </p>

      {boardState === StrategyBoardState.SET_GOAL && (
        <div className="mt-[21px] flex items-start justify-center gap-[21px]">
          <button
            onClick={() => onCapacitySelect(Capacity.Low)}
            className="group relative h-28 w-48 overflow-hidden rounded-[8px] p-[2px]"
            style={{ background: "var(--zeemee-gradient)" }}
          >
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background text-center text-sm leading-5 font-bold text-foreground transition-colors group-hover:bg-accent">
              {t("strategyBoard.capacityPicker.capacityLow")}
            </div>
          </button>
          <button
            onClick={() => onCapacitySelect(Capacity.Medium)}
            className="group relative h-28 w-48 overflow-hidden rounded-[8px] p-[2px]"
            style={{ background: "var(--zeemee-gradient)" }}
          >
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background text-center text-sm leading-5 font-bold text-foreground transition-colors group-hover:bg-accent">
              {t("strategyBoard.capacityPicker.capacityMedium")}
            </div>
          </button>
          <button
            onClick={() => onCapacitySelect(Capacity.High)}
            className="group relative h-28 w-48 overflow-hidden rounded-[8px] p-[2px]"
            style={{ background: "var(--zeemee-gradient)" }}
          >
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background text-center text-sm leading-5 font-bold text-foreground transition-colors group-hover:bg-accent">
              {t("strategyBoard.capacityPicker.capacityHigh")}
            </div>
          </button>
        </div>
      )}
    </div>
  );
}
